'use strict';

const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const isDesktop = Odigeo.SessionScope.flow === 'desktop';
const flow = Odigeo.Utils.isRequestApp('dp') ? 'dynpack' : 'flights';
const trackingUtils = require('od-modules/utils/tracking.utils');
const Flights = require('od-apps/app.flights');

module.exports = withRenderedMain(BaseView.extend({
    cons: {
        open: 'open',
    },
    selectors: {
        container: '.expensive_repricing_container',
    },
    events: {
        'tap .expensive_repricing_close_btn': 'close',
        'tap .reject_repricing': 'rejectRepricing',
    },
    isVisible: false,
    toggleTemplate(isVisible) {
        const $container = this.$el.find(this.selectors.container);
        $container.toggleClass(this.cons.open, isVisible);
        Odigeo.Session.remove('repricingMAPI');
    },
    close() {
        this.toggleTemplate(false);
    },
    rejectRepricing() {
        trackingUtils.trackEvent('repricing_popup', 'repricing_return');
        this.toggleTemplate(false);
        if (flow === 'dynpack') {
            Odigeo.trigger(this.id + ':onBackToResults', 'accommodation');
        } else {
            const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            Odigeo.Router.navigate('results', {params: Flights.searchParamsStringify(searchParameters), removeParametersFromQueryString: true});
        }
        if (!isDesktop) {
            Odigeo.Router.reload();
        }
    },
}));
